import LockTableCellRenderer from "./LockTableCellRenderer";
import UserTime from "../../user_time";

export default class DayCellRenderer extends LockTableCellRenderer {
    generateContent(cell)
    {
        this.buildContent(cell);
        this.addTooltip(cell);
    }

    buildContent(cell)
    {
        cell.getCellEl().innerHTML = this.parseTime(cell.getValue());
    }

    parseTime(time)
    {
        return time != 0 ? UserTime.formatTime(time) : "&nbsp;";
    }

    addTooltip(cell)
    {
        //Note: should be implemented in inheritor
    }

    getLeftBorderSpecificClassName(cell)
    {
        var prevColIdx = cell.getColIdx() - 1;
        if (this.isHovered(cell) || this.isHovered(cell.getRow().getCell(prevColIdx)))
        {
            return "hoveredDayCellLeftBorder";
        }
        return "";
    }
}



// WEBPACK FOOTER //
// ./web/js/locktable/renderers/DayCellRenderer.js